import DefaultLayout from "@/layouts/DefaultLayout";
import { NextPage } from "next";
import { NextSeo } from "next-seo";
import InfiniteScroll from "react-infinite-scroll-component";
import Circular from "@/components/Circular";
import SearchResultGroup from "@/components/SearchResultGroup";
import { SearchResultTabType } from "@/consts/tabType";
import NotFoundSearchView from "@/components/NotFoundSearchView";
import usePageView from "@/hooks/usePageView";
import FlexibleGrid from "@/components/FlexibleGrid";
import ListItem from "@/features/list/components/ListItem";
import useListSearch from "@/features/list/hooks/useListSearch";

const SearchListsPage: NextPage = () => {
  usePageView();

  const {
    keyword,
    pagination: { data, dataLength, next, hasNext, notFound },
  } = useListSearch("/search/lists");

  return (
    <DefaultLayout className="!bg-white">
      <NextSeo
        title={`検索結果`}
        description={`TECTURE内のリストを検索した結果`}
        noindex={true}
      />

      <SearchResultGroup keyword={keyword} tabType={SearchResultTabType.List}>
        <InfiniteScroll
          style={{ overflow: "visible" }}
          dataLength={dataLength}
          next={next}
          hasMore={hasNext}
          loader={<Circular />}
        >
          <FlexibleGrid>
            {data.map((list) => {
              return (
                <li key={list.id}>
                  <ListItem list={list} hasUserIcon={true} />
                </li>
              );
            })}
          </FlexibleGrid>
        </InfiniteScroll>
        {notFound && <NotFoundSearchView />}
      </SearchResultGroup>
    </DefaultLayout>
  );
};

export default SearchListsPage;
